import React from "react";
import CouponCardTheme2 from "components/CouponCardTheme2";
import "./featured-coupon.scss";

const FeaturedCoupon = ({ featuredCouponList, featuredCouponTitle }) => {
  return (
    <>
      <div className="new-sale-product">
        <div className="container">
          <div className="container-fluid">
            <div className="deals-product">
              <div className="heading">
                <h2>{featuredCouponTitle}</h2>
                <a href="coupons">
                  View All{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="currentColor"
                      d="M8.6 3.4L14.2 9H2v2h12.2l-5.6 5.6L10 18l8-8l-8-8z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div className="product-row deal-all-wrapper">
              <div className="new-sale-all-wrapper">
                {featuredCouponList &&
                  featuredCouponList.slice(0, 5).map((coupon, index) => {
                    return (
                      <CouponCardTheme2
                        coupon={coupon}
                        key={index}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturedCoupon;
